/*set components*/
import Home  from './Home';

/*set icons*/
import Face3Icon from '@mui/icons-material/Face3';


export const routes_modules = [
  {
    name: "Condominios",
    path: "/:id",
    component: Home,
    menu: true,
    private: false,
    icon: <Face3Icon />,
    title: "Condominios",
    subtitle: "Desarrollos inmobiliarios"
  },
];
